import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { LearningMode } from 'app/types';
import { MODES } from 'pages/Learning/learningMeta';
import LearningModeCard from 'pages/Learning/components/LearningModeCard';

interface LearningModeGridProps {
  label?: string;
  recommendedMode?: LearningMode;
  counts?: Partial<Record<LearningMode, number>>;
  onStart: (mode: LearningMode) => void;
  starting?: boolean;
  /** True when there is an in-progress session — relabels start buttons
   *  to "Почати нову сесію" so it's clear clicking will replace the
   *  current run, not stack a second one. */
  hasInProgressSession?: boolean;
}

const LearningModeGrid: React.FC<LearningModeGridProps> = ({
  label,
  recommendedMode,
  counts,
  onStart,
  starting,
  hasInProgressSession,
}) => {
  return (
    <Box>
      {label && (
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={1.5}
          sx={{ mb: 2, mt: 0.5 }}
        >
          <Typography
            sx={{
              color: 'text.secondary',
              fontSize: 12,
              fontWeight: 800,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </Typography>
          <Box sx={{ bgcolor: 'divider', flex: 1, height: '1px' }} />
        </Stack>
      )}
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(4, 1fr)',
          },
        }}
      >
        {MODES.map((m) => (
          <LearningModeCard
            key={m.id}
            mode={m}
            count={counts?.[m.id]}
            recommended={m.id === recommendedMode}
            onStart={() => onStart(m.id)}
            disabled={starting}
            startLabel={
              hasInProgressSession ? 'Почати нову сесію' : 'Почати'
            }
          />
        ))}
      </Box>
    </Box>
  );
};

export default LearningModeGrid;
